<div>
  <div class="flex items-center justify-between mb-2">
    <label class="font-semibold">Items</label>
    <div class="flex gap-2">
      @if (canUploadPDFDrawing) {
        <p-button
          label="Upload PDF Drawing"
          icon="pi pi-file-pdf"
          (onClick)="onUploadDrawing()"
        />
      }
      <p-button
        label="Upload CAD"
        icon="pi pi-upload"
        (onClick)="onAddBlueprint()"
      />
      <p-button
        label="Bulk Upload CAD"
        icon="pi pi-cloud-upload"
        (onClick)="onBulkUpload()"
      />
      <p-button
        label="Add Blueprint"
        severity="secondary"
        icon="pi pi-file"
        (onClick)="onOpenBlueprintSelector()"
      />
      <p-button
        label="New Line"
        severity="secondary"
        icon="pi pi-plus"
        (onClick)="onAddBlankItem()"
      />
    </div>
  </div>

  <app-blueprint-selector-modal
    [(visible)]="showBlueprintSelector"
    [header]="blueprintSelectorHeader"
    [blueprints]="allBlueprints"
    [confirmLabel]="drawingBlueprintConfirmLabel"
    [showSkip]="hasPendingDrawings"
    [skipHint]="drawingSkipHint"
    [skipTooltip]="drawingSkipTooltip"
    [nameSuggestions]="drawingNameSuggestions"
    [customTreeProposal]="pendingCustomTreeProposal"
    (blueprintConfirmed)="onBlueprintSelected($event)"
    (customTreeConfirmed)="onCustomTreeSelected()"
    (skipped)="onSkipDrawingBlueprint()"
  ></app-blueprint-selector-modal>

  @if (itemBeingCadLinked !== null) {
    <app-quote-item-link-cad
      [initialLinkItems]="[itemBeingCadLinked!]"
      (confirmed)="onConfirmCadLink($event)"
      (closed)="itemBeingCadLinked = null"
    ></app-quote-item-link-cad>
  }

  @if (itemBeingCadViewed !== null) {
    <app-quote-item-linked-cad-modal
      [visible]="true"
      [itemName]="itemBeingCadViewed!.name"
      [cadObjectIds]="itemBeingCadViewed!.cad_object_ids"
      (closed)="itemBeingCadViewed = null"
    />
  }

  @if (itemBeingDrawingViewed !== null) {
    <app-quote-item-linked-drawing-modal
      [visible]="true"
      [itemName]="itemBeingDrawingViewed!.name"
      [drawingFileId]="itemBeingDrawingViewed!.drawing_file_id ?? null"
      (closed)="itemBeingDrawingViewed = null"
    />
  }

  @if (showBlueprintCadLink) {
    <app-quote-item-link-cad
      mode="blueprint"
      [allBlueprints]="allBlueprints"
      (confirmed)="onConfirmBlueprintCadLink($event)"
      (closed)="showBlueprintCadLink = false"
    ></app-quote-item-link-cad>
  }

  @if (showBulkCadUpload) {
    <app-quote-item-link-cad
      mode="bulk"
      [allBlueprints]="allBlueprints"
      (confirmed)="onConfirmBlueprintCadLink($event)"
      (closed)="showBulkCadUpload = false"
    ></app-quote-item-link-cad>
  }

  @if (canUploadPDFDrawing && showDrawingUpload) {
    <app-quote-item-upload-drawing
      [excludedDrawingIds]="drawingFileIdsInEditor()"
      (confirmed)="onDrawingConfirmed($event)"
      (closed)="showDrawingUpload = false"
    ></app-quote-item-upload-drawing>
  }

  @if (itemBeingPricingEdited !== null && pricingModelForEditedItem) {
    <app-quote-item-pricing-parameters
      [pricingModel]="pricingModelForEditedItem"
      [pricingParameters]="itemBeingPricingEdited!.pricing_parameters"
      [cadObjects]="cadObjectsForPricingEditedItem"
      (saved)="onSavePricingParameters($event)"
      (closed)="onClosePricingParameters()"
    />
  }

  <!-- The next div gives the grid column widths.
  This needs to match the grid column widths in quote-item-data-tree.component.html
  -->
  <div
    class="pt-3 grid gap-2 mb-2 bg-surface-switch-100 text-xs font-semibold text-muted-color border-b pb-1"
    [ngClass]="
      tradeStudyToolFeaturesEnabled
        ? 'grid-cols-[25px_1.2fr_75px_0.5fr_55px_1.3fr_80px_1.8fr_0.9fr_40px_110px]'
        : 'grid-cols-[25px_1.2fr_75px_0.5fr_55px_1.3fr_80px_70px_0.9fr_1fr_40px_110px]'
    "
  >
    <div></div>
    <!-- 25px -->
    <div>Name</div>
    <!-- 1.2fr -->
    <div>Qty</div>
    <!-- 75px -->
    <div>Qty Type</div>
    <!-- 0.5fr -->
    <div pTooltip="Parts processed in one batch run" tooltipPosition="top">
      Batch
    </div>
    <!-- 55px -->
    <div>Pricing</div>
    <!-- 1.3fr -->
    <div>Cost</div>
    <!-- 80px -->
    @if (!tradeStudyToolFeaturesEnabled) {
      <div>Markup %</div>
      <!-- 70px -->
      <div>Tax Code</div>
      <!-- 0.9fr -->
    }
    <div>Material</div>
    <!-- 1fr / 1.8fr when trade study enabled -->
    @if (tradeStudyToolFeaturesEnabled) {
      <div>CapEx</div>
      <!-- 0.9fr -->
    }
    <div>CAD</div>
    <!-- 40px -->
    <div>Actions</div>
    <!-- 110px -->
  </div>

  @if (quoteItemDataEditorService.items(); as items) {
    @if (items && items.length > 0) {
      @if (
        (quoteItemDataEditorService.dragging$ | async) || true;
        as draggingWrapper
      ) {
        <div
          class="flex flex-col gap-1"
          [class.dragging-active]="quoteItemDataEditorService.dragging$ | async"
        >
          @for (
            item of rootItems;
            track item.persistent_id;
            let index = $index
          ) {
            <div
              pDroppable
              (drop)="quoteItemDataEditorService.drop(item, 'before')"
              class="drop-line"
            ></div>
            <app-quote-item-data-tree
              [item]="item"
              [currencyCode]="currencyCode"
              [tradeStudyToolFeaturesEnabled]="tradeStudyToolFeaturesEnabled"
              [equipmentOptions]="equipmentOptions"
              [consumablesEnabled]="consumablesEnabled"
              [consumableOptions]="consumableOptions"
              (addChild)="onAddChildToItem($event)"
              (removeItem)="onRemoveItem($event)"
              (openCadLink)="onOpenCadLinkForItem($event)"
              (relinkCad)="onRelinkCadForItem($event)"
              (openPricingParameters)="onOpenPricingParametersForItem($event)"
            />
            @if ($last) {
              <div
                pDroppable
                (drop)="quoteItemDataEditorService.drop(item, 'endOfList')"
                class="drop-line"
              ></div>
            }
          }
        </div>
      }
    } @else {
      <div class="border rounded p-8 text-center text-muted-color">
        <p>
          No items yet. Click
          @if (pdfDrawingUploadEnabled) {
            "Upload CAD", "Upload PDF Drawing", "Add Blueprint" or "New Line"
          } @else {
            "Upload CAD", "Add Blueprint" or "New Line"
          }
          to get started.
        </p>
      </div>
    }
  }
</div>
